
<template>
  <v-container>
    <v-row>
      <v-col>
        <preorders-table />
      </v-col>
      <v-col cols="3">
        <preorders-filters />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PreordersTable from './../components/preordini/PreordersTable'
  import PreordersFilters from './../components/preordini/PreordersFilters'

  export default {
    name: 'PreordiniDevices',

    components: {
      PreordersTable,
      PreordersFilters
    },
  }
</script>

<style>
</style>